<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><span epub:type="pagebreak" id="pageix" title="ix">CONTENTS</span></h2>
<table>
<tbody><tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/fm02">Foreword by Art Hansen</a></p></td>
</tr>
<tr>
<td><p class="toca"><a href="#/xhtml/chapter01"><strong><span class="gray">ONE</span></strong></a></p></td>
<td><p class="tocx"><a href="#/xhtml/chapter01"><strong>THE GATES WERE CLOSED AFTER US</strong></a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec1"><span class="gray"><em>Manzanar Children’s Village</em></span></a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec2">Resettlement in Los Angeles County</a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec3"><span class="gray"><em>“Representative and Talented Nisei”</em></span></a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec4">Resettlement in the Midwest</a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec5">Resettlement on the East Coast</a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec6"><span class="gray"><em>Seabrook Farms</em></span></a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec7">Resettlement in the Near West</a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec8">Making a Home in Temporary Housing</a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec9"><span class="gray"><em>Bainbridge Island</em></span></a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec10">Life in Temporary Housing</a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><a href="#/xhtml/chapter01#sec11">Finding Work in Postwar America</a></p></td>
</tr>
<tr>
<td><p class="toca"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><strong><span class="gray">TWO</span></strong></span></p></td>
<td><p class="tocx"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><strong>WAR IS OVER</strong></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec1" title="Link target outside of Sample">Political Gains</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec2" title="Link target outside of Sample"><span class="gray"><em>Kurihara and Wakayama</em></span></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec3" title="Link target outside of Sample">Legal Victories and Defeats</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span epub:type="pagebreak" id="pagex" title="x"><span href="#/xhtml/chapter02#sec4" title="Link target outside of Sample">Japanese Americans in the U.S. Military</span></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec5" title="Link target outside of Sample">On the Move</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec6" title="Link target outside of Sample"><span class="gray"><em>Postwar Art and Pop Culture</em></span></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec7" title="Link target outside of Sample">Love and Politics</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter02#sec8" title="Link target outside of Sample">Getting an Education</span></p></td>
</tr>
<tr>
<td><p class="toca"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><strong><span class="gray">THREE</span></strong></span></p></td>
<td><p class="tocx"><a href="#/xhtml/chapter01"><strong>TAKING A STAND</strong></a></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec1" title="Link target outside of Sample"><span class="gray"><em>The Debate about Terminology</em></span></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec2" title="Link target outside of Sample">Activism at the Local Level and Beyond</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec3" title="Link target outside of Sample">Progress and Backlash</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec4" title="Link target outside of Sample">Uncovering a Cover-Up</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec5" title="Link target outside of Sample">Telling Their Stories</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec6" title="Link target outside of Sample">Legal Remedies</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter03#sec7" title="Link target outside of Sample">A Path to Success</span></p></td>
</tr>
<tr>
<td><p class="toca"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><strong><span class="gray">FOUR</span></strong></span></p></td>
<td><p class="tocx"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><strong>NEVER AGAIN</strong></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter04#sec1" title="Link target outside of Sample"><span class="gray"><em>“Journey to Our Community Healing”</em></span></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter04#sec2" title="Link target outside of Sample">Formal Recognition</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter04#sec3" title="Link target outside of Sample">Sacrifice and Loyalty</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter04#sec4" title="Link target outside of Sample">Speaking Out</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter04#sec5" title="Link target outside of Sample"><span class="gray"><em>“No Redress”</em></span></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/chapter04#sec6" title="Link target outside of Sample">Past, Present, and Future</span></p></td>
</tr>
<tr>
<td><p class="toca"><span href="#/xhtml/bm01" title="Link target outside of Sample"><strong><span class="gray">EPILOGUE</span></strong></span></p></td>
<td><p class="tocx"><span href="#/xhtml/bm01" title="Link target outside of Sample"><strong>MAKING DESERTS BLOOM</strong></span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/bm01#sec1" title="Link target outside of Sample">“No More Manzanars”</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/bm01#sec2" title="Link target outside of Sample">Afterword</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/bm01#sec3" title="Link target outside of Sample">Bibliography</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/bm01#sec4" title="Link target outside of Sample">Image Credits</span></p></td>
</tr>
<tr>
<td><p class="toc"> </p></td>
<td><p class="toc"><span href="#/xhtml/bm01#sec5" title="Link target outside of Sample">About the Authors</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0c242df8